export default {
  path: "/SectionContent/PropertyDamageWitnessInformation",
  name: "Property Damage / Witness Information",
  htmlContent: "property_damage_witness_information.html",
  headings: [
    { id: "n95DamageOtherThanVehicle", text: "95. Damage other than Vehicle", type: "field" },
    { id: "n96Owner", text: "96. Owner", type: "field" },
    {
      id: "n97WitnessNameAddressTelephoneNumber",
      text: "97. Witness Name/Address/Telephone Number",
      type: "field",
    },
  ],
};
